import React, { useEffect } from "react";
import { SearchOutlined, RightOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Steps,
  Button,
  message,
  Form,
  Input,
  Image,
  Carousel,
  Card,
  Divider,
  Select,
  DatePicker,
  Radio,
  Checkbox,
} from "antd";
import FileUploadWithCrop from "./FileUploadWithCrop";
import RegistrationService from "../../api/registration.service";
const { Option } = Select;
const { TextArea } = Input;

const BasicInfo = () => {
  const [form] = Form.useForm();

  const onBasicInfoSave = async (values) => {
    console.log(values);
    const data = {
      "mode": "ADD",
      "memberId": 0,
      "date_of_join":values.date_of_join,
      "formdata": values,
      
    };

    const x = RegistrationService.RegBasicInfoSave(data);
  };

  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };

  const onGenderChange = (e) => {
    console.log(`radio checked:${e.target.value}`);
  };

  const onIsBeginerChange = (e) => {
   // console.log(`checked = ${e.target.checked}`);
  };


  const defaultValues = {
  memberId:0,
  mode:'ADD',
  member_code:'',
  date_of_join:null,
  member_fname:'',
  member_lname:'',
  primary_mobile:'',
  whatsapp_no:'',
  mobile_two:'',
  mobile_three:'',
  primary_email:'',
  email_second:'',
  address_one:'',
  address_two:'',
  date_of_birth:null,
  gender:'',
  father_name:'',
  monther_name:'',
  school:'',
  mem_class:'',
  weekly_holiday:'',
  school_timing:'',
  occupation_id:0,
  is_begineer:false,
  playing_for:'',
  earlier_playing:'',
  }

  useEffect(() => {
    form.setFieldsValue(defaultValues)
   }, [form, defaultValues])

  return (
    <div className="form-input-style">
      <Row className="login-first-step-row" style={{ background: "white" }} >
        <Col
          className="login-first-step-block-1"
          xs={24}
          xl={24}
         
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onBasicInfoSave}
            autoComplete="off"
            initialValues={defaultValues}
          >
            <Row gutter={20}>
              <Col className="gutter-row" xs={24} xl={6}>
                <Form.Item name="member_code" label="Member Code">
                  <Input placeholder="" />
                </Form.Item>
                <Form.Item name="memberId" label="memberId" hidden={true}>
                    <Input type="text" />
                </Form.Item>
                <Form.Item name="mode" label="mode" hidden={true}>
                    <Input type="text" />
                </Form.Item>
              </Col>
              <Col className="gutter-row" xs={24} xl={6}>
                <Form.Item name="date_of_join" label="Date of joining">
                  <DatePicker  format="YYYY-MM-DD" onChange={onChange} style={{width:"100%"}}/>
                </Form.Item>
              </Col>
              <Col xs={24} xl={6}>
                <Form.Item name="member_fname" label="First Name">
                  <Input placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="member_lname" label="Last Name">
                  <Input placeholder="" />
                </Form.Item>
              </Col>
            </Row>

           

            <Row gutter={20}>
              <Col xs={24} xl={6}>
                <Form.Item name="primary_mobile" label="Primary Mobile">
                  <Input placeholder="" addonBefore="+91" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="whatsapp_no" label="Whatsapp No">
                  <Input placeholder="" addonBefore="+91" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="mobile_two" label="Mobile 2">
                  <Input placeholder="" addonBefore="+91" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="mobile_three" label="Mobile 3">
                  <Input placeholder="" addonBefore="+91" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={20}>

            <Col xs={24} xl={6}>
                <Form.Item name="date_of_birth" label="DOB">
                  <DatePicker  format="YYYY-MM-DD" onChange={onChange} style={{width:"100%"}}/>
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="gender" label="Gender">
                  <Radio.Group onChange={onGenderChange} defaultValue="M">
                    <Radio.Button value="M">Male</Radio.Button>
                    <Radio.Button value="F">Female</Radio.Button>
                    <Radio.Button value="T">Transgender</Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="primary_email" label="Primary Email">
                  <Input placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="email_second" label="Email 2">
                  <Input placeholder="" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={20}>
              <Col xs={24} xl={12}>
                <Form.Item name="address_one" label="Address Line 1">
                  <TextArea rows={2} placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={12}>
                <Form.Item name="address_two" label="Address Line 2">
                  <TextArea rows={2} placeholder="" />
                </Form.Item>
              </Col>
            </Row>

          

            <Row gutter={20}>
              <Col xs={24} xl={6}>
                <Form.Item name="father_name" label="Father Name">
                  <Input placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="monther_name" label="Mother Name">
                  <Input placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="school" label="School">
                  <Input placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="mem_class" label="Class">
                  <Input placeholder="" />
                </Form.Item>
              </Col>
            </Row>

           

            <Row gutter={20}>
              <Col xs={24} xl={6}>
                <Form.Item name="weekly_holiday" label="Weekly Holiday">
                  <Input placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="school_timing" label="School Timing">
                  <Input placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="occupation_id" label="Occupation">
                  <Select className="text-left" defaultValue="0">
                    <Option key="0" value="0">
                      Occupation
                    </Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="is_begineer" label=" ">
                  <Checkbox onChange={onIsBeginerChange}>Is Beginner</Checkbox>
                </Form.Item>
              </Col>
            </Row>

         

            <Row gutter={20}>
              <Col xs={24} xl={6}>
                <Form.Item name="playing_for" label="Playing For">
                  <Input placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} xl={6}>
                <Form.Item name="earlier_playing" label="Earlier Playing">
                  <Input placeholder="" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                shape="round"
                style={{ float: "right" }}
                className="theme-button"
              >
                Continue
                <RightOutlined />
              </Button>
            </Form.Item>
          </Form>
        </Col>
        
      </Row>
    </div>
  );
};

export default BasicInfo;
